import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import InfoIcon from "@mui/icons-material/Info";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import SendIcon from "@mui/icons-material/Send";
import FolderIcon from "@mui/icons-material/FolderCopyOutlined";
import PermIdIcon from "@mui/icons-material/PermIdentity";

import useActions, { useAppDispatch, useAppSelector } from "../../app/hooks";
import IconButton from "@mui/material/IconButton";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import { Workspace } from "../../types/Dash";
import { Folder } from "../../types/Folder";
import { Role } from "../../types/Role";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import DashInfoForm from "./DashInfoForm";
import DashCloneForm from "./DashCloneForm";
import DashMoveForm from "./DashMoveForm";
import Badge from "@mui/material/Badge";
import CircularProgress from "@mui/material/CircularProgress";
//import DashCreationForm from "../generation/DashCreationForm";

import Reticle from "./Reticle";

import AttachRoleForm from "./AttachRoleForm";

/**
 * A single library item showing a Dash.
 *
 * @export
 * @param {{
 *   dash: Dash;
 * }} props
 * @return {*}
 */
export default function DashLibraryFolder(props: {
  folder: Folder;
  workspaceRole: string;
  favourite: boolean;
  workspaces: Array<Workspace> | null;
  roles: Array<Role> | null;
  currentWorkspace: Workspace | null;
}) {
  const actions = useActions();
  const folder = props.folder;

  // useEffect(() => {
  //If the preview is not loaded, load it.
  // if (
  //   !props.documentTemplate.imagePreview ||
  //   (!props.documentTemplate.imagePreview.data === null &&
  //     props.documentTemplate.imagePreview.status === "idle")
  // ) {
  //   console.log("Going to load preview");
  //   // // Asynchronously get all previews.
  //   actions.getDocumentImagePreview(props.documentTemplate);
  //   }
  // });

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [infoOpen, setInfoOpen] = React.useState(false);
  const [cloneOpen, setCloneOpen] = React.useState(false);
  const [moveOpen, setMoveOpen] = React.useState(false);

  const [attachRoleOpen, setAttachRoleOpen] = React.useState(false);

  const [generateOpen, setGenerateOpen] = React.useState(false);

  const handleFolderClicked = () => {
    actions.changeFolder({id:props.folder.id, name:props.folder.name});
  };

  const handleEditClicked = () => {
    setAnchorEl(null);
    //actions.setEditingDash(props.folder);
  };
  const handleDeleteClicked = () => {
    if (window.confirm("Are you sure you want to delete the folder?")) {
      setAnchorEl(null);
      actions.deleteFolder(props.folder);
    }
  };

  const handleFavoriteClicked = () => {
    //setAnchorEl(null);
    //actions.favouriteDocumentTemplate(props.documentTemplate);
  };
  const handleUnfavoriteClicked = () => {
    //setAnchorEl(null);
    //actions.unfavouriteDocumentTemplate(props.documentTemplate);
  };
  const handleInfoClicked = () => {
    setAnchorEl(null);
    setInfoOpen(true);
  };

  const handleCloneToWorkspace = () => {
    setCloneOpen(true);
    setAnchorEl(null);
  };

  const handleMoveToWorkspace = () => {
    setMoveOpen(true);
    setAnchorEl(null);
  };

  const handleAttachRole = () => {
    setAttachRoleOpen(true);
    setAnchorEl(null);
  };

  const handleAttachRoleClose = () => {
    setAttachRoleOpen(false);
  };

  let itemContent = (
    <CircularProgress size="150px" style={{ padding: "10px" }} />
  );

  itemContent = (
    <FolderIcon
        color={"primary"}
        sx={{ fontSize: 96 }}
      />
  );
  /*
  src={URL.createObjectURL(
          props.dash.imagePreview?.data as Blob
        )}
  if (
    !props.dash.imagePreview ||
    props.dash.imagePreview.data == null ||
    props.dash.imagePreview.status === "failed"
  ) {
    // Show the file icon
    itemContent = (
      <InsertDriveFileIcon
        color={isDeleted ? "inherit" : "primary"}
        sx={{ fontSize: 96 }}
      />
    );
  } else if (props.dash.imagePreview?.data !== null) {
    
  }*/

  function getRole(id:number) {
    if (props.roles !== null) {
      const matches = props.roles.filter(_ => _.id == id);

      if (matches.length == 0) {
        return null;
      }
      else {
        return matches[0];
      }
    }
    else {
      return null;
    }
  }

  function folderRoles() {
    const list:Array<Role> = [];

    props.folder.folders_roles.forEach(_ => {
      const res = getRole(_.role_id);

      if (res !== null) {
        list.push(res);
      }
    });

    return list;
  }

  return (
    <ImageListItem
      key={folder.id}
      sx={{
        justifyContent: "center",
        display: "flex",
        width: 200,
        height: 250,
      }}
    >
      
      <Paper
        sx={{
          background: "#CCCCCC",
          justifyContent: "center",
          display: "flex",
          width: 200,
          height: 250,
          position: "relative",
          "&:hover .folder-reticle": {
            opacity: 1,
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
        <IconButton
            data-index={folder.id}
            key={folder.id}
            onClick={(e) => handleFolderClicked()}
            disableRipple
            sx={{
              "&:hover": {
                bgcolor: "transparent",
              },
            }}
          >
            
            {itemContent}
          </IconButton>
          <Reticle />
        </Box>
      </Paper>
      <ImageListItemBar
        sx={{ "& .MuiImageListItemBar-title": { fontWeight: "bold" }, }}
        title={folder.name}
        position="below"
        actionIcon={
          <>
            <IconButton
              aria-label={`info about ${folder.name}`}
              onClick={handleOpenMenu}
            >
              <MoreVertIcon />
            </IconButton>
            { /*<IconButton
              key="heart"
              sx={{ color: props.favourite? "blue" : "black"}}
              onClick={ () => {
                if (props.favourite) {
                  handleUnfavoriteClicked()
                }
                else {
                  handleFavoriteClicked()
                }
              }}
              >
              { props.favourite && <FavoriteIcon /> }
              { !props.favourite && <FavoriteBorderIcon /> }
            </IconButton> */}
          </>
        }
        
      >
        
        </ImageListItemBar>
      
      { props.workspaceRole !== undefined && props.workspaceRole != "FREE" &&
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}

      >
        { /*<MenuItem onClick={handleEditClicked}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
      </MenuItem> */}
        <MenuItem onClick={handleDeleteClicked}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
        { /*}
        { !props.favourite && <MenuItem onClick={handleFavoriteClicked}>
          <ListItemIcon>
            <FavoriteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Favorite</ListItemText>
        </MenuItem> }
        { props.favourite && <MenuItem onClick={handleUnfavoriteClicked}>
          <ListItemIcon>
            <FavoriteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Unfavorite</ListItemText>
        </MenuItem> } */ }
        
        
        <MenuItem onClick={handleInfoClicked}>
          <ListItemIcon>
            <InfoIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Folder Properties...</ListItemText>
        </MenuItem>
        { /*<MenuItem onClick={handleMoveToWorkspace} >
          <ListItemIcon>
            <CopyAllIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Move to Workspace</ListItemText>
      </MenuItem> */ }
        <MenuItem onClick={handleAttachRole} >
          <ListItemIcon>
            <CopyAllIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Attach Role</ListItemText>
        </MenuItem>
        {folderRoles().map(__ => <MenuItem key={"RoleFolder_" + __.id}>
          <ListItemIcon>
            <PermIdIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{ __.name }</ListItemText>
        </MenuItem> )}
      </Menu>
      }

      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Dash folder properties</DialogTitle>
        <DialogContent>
          <Stack spacing={1.5} sx={{ pt: 1 }}>
            <InfoRow label="Id" value={String(folder.id)} />
            <InfoRow label="Name" value={folder.name} />
            <InfoRow label="Parent folder id" value={String(folder.parent_folder_id)} />
            <InfoRow label="Created at" value={folder.created_at ?? "—"} />
            <InfoRow label="Updated at" value={folder.updated_at ?? "—"} />
            <InfoRow label="Deleted at" value={folder.deleted_at ?? "—"} />
            <InfoRow
              label="Folders roles"
              value={
                folder.folders_roles?.length
                  ? folder.folders_roles.map((fr) => `role_id: ${fr.role_id}, folder_id: ${fr.folder_id}`).join("; ")
                  : "—"
              }
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      { attachRoleOpen &&
        <AttachRoleForm
          currentWorkspace={props.currentWorkspace}
          parentCloseHandle={handleAttachRoleClose}
          roles={props.roles!}
          dash={null}
          folder={props.folder}
        ></AttachRoleForm> }
    </ImageListItem>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
        {value}
      </Typography>
    </Box>
  );
}
